module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fb-Ga-Ha-Ia-Gc.437fb6a3.png";